<script>
import LocaleButton from '@components/locale-button'
import UserButton from '@components/user-button'
import NotificationBar from '@views/notifications'
import NotificationButton from '@components/notification-button'

const ALLOWED_USER_ROLES = [
  'SUPERUSER',
  'DICTIONARIES_OPERATOR',
  'DOCUMENTS_OPERATOR',
  'GUEST',
]

export default {
  components: {
    NotificationButton,
    LocaleButton,
    NotificationBar,
    UserButton,
  },
  data() {
    return {
      menuItems: [
        {
          id: 1,
          name: 'dashboard',
          subItems: [
            {
              id: 11,
              name: 'dashboard',
              link: '/dashboard',
              allowedRoles: ['SUPERUSER', 'REPORTS_OPERATOR'],
            },
          ],
        },
        {
          id: 7,
          name: 'workshops',
          subItems: [
            {
              id: 70,
              name: 'warehouses',
              link: '/warehouses',
              allowedRoles: ALLOWED_USER_ROLES,
            },
            {
              id: 71,
              name: 'workshops',
              link: '/workshops',
              allowedRoles: ALLOWED_USER_ROLES,
            },
            {
              id: 72,
              name: 'devices',
              link: '/devices',
              allowedRoles: ALLOWED_USER_ROLES,
            },
          ],
        },
        {
          id: 2,
          name: 'actions',
          subItems: [
            {
              id: 21,
              name: 'accept',
              link: '/documents/accept',
              allowedRoles: ALLOWED_USER_ROLES,
            },
            {
              id: 22,
              name: 'completeSet',
              link: '/documents/completeSet',
              allowedRoles: ALLOWED_USER_ROLES,
            },
            {
              id: 23,
              name: 'shipment',
              link: '/documents/shipment',
              allowedRoles: ALLOWED_USER_ROLES,
            },
            {
              id: 24,
              name: 'returns',
              link: '/documents/returns',
              allowedRoles: ALLOWED_USER_ROLES,
            },
            {
              id: 25,
              name: 'writeOff',
              link: '/documents/writeOff',
              allowedRoles: ALLOWED_USER_ROLES,
            },
            {
              id: 26,
              name: 'change',
              link: '/documents/change',
              allowedRoles: ALLOWED_USER_ROLES,
            },
            {
              id: 27,
              name: 'searchPlug',
              link: '/documents/searchPlug',
              allowedRoles: ALLOWED_USER_ROLES,
            },
          ],
        },
        {
          id: 3,
          name: 'reports',
          subItems: [
            {
              id: 31,
              name: 'reports',
              link: '/reports',
              allowedRoles: ['SUPERUSER', 'REPORTS_OPERATOR'],
            },
            {
              id: 32,
              name: 'alerts',
              link: '/alerts',
              allowedRoles: ['SUPERUSER', 'REPORTS_OPERATOR'],
            },
            {
              id: 33,
              name: 'events',
              link: '/events',
              allowedRoles: ['SUPERUSER', 'EVENTS_OPERATOR'],
            },
            {
              id: 34,
              name: 'remains',
              link: '/remains',
              allowedRoles: ['SUPERUSER', 'EVENTS_OPERATOR'],
            },
            {
              id: 36,
              name: 'heartbeats',
              link: '/heartbeats',
              allowedRoles: ['SUPERUSER', 'EVENTS_OPERATOR'],
            },
          ],
        },
        {
          id: 4,
          name: 'systemSettings',
          subItems: [
            {
              id: 41,
              name: 'systemSettings',
              link: '/systemSettings',
              allowedRoles: ['SUPERUSER'],
            },
          ],
        },
        {
          id: 5,
          name: 'administration',
          subItems: [
            {
              id: 51,
              name: 'settings',
              link: '/control/settings',
              allowedRoles: ['SUPERUSER'],
            },
            {
              id: 52,
              name: 'users',
              link: '/control/users',
              allowedRoles: ['SUPERUSER'],
            },
            {
              id: 53,
              name: 'roles',
              link: '/control/roles',
              allowedRoles: ['SUPERUSER'],
            },
          ],
        },
        {
          id: 6,
          name: 'dictionaries',
          subItems: [
            {
              id: 61,
              name: 'dictionaries',
              link: '/dictionaries/list',
              allowedRoles: ALLOWED_USER_ROLES,
            },
            {
              id: 62,
              name: 'nomenclature',
              link: '/dictionaries/goods',
              allowedRoles: ALLOWED_USER_ROLES,
            },
            {
              id: 63,
              name: 'organizations',
              link: '/dictionaries/organizations',
              allowedRoles: ALLOWED_USER_ROLES,
            },
            {
              id: 64,
              name: 'contacts',
              link: '/dictionaries/contacts',
              allowedRoles: ALLOWED_USER_ROLES,
            },
          ],
        },
      ],
    }
  },
  computed: {
    filteredMenuItems() {
      var result = []
      this.menuItems.forEach(item => {
        var subItems = item.subItems.filter(
          subItem =>
            !subItem.allowedRoles || this.userHasRole(subItem.allowedRoles)
        )
        if (subItems.length > 0) result.push({ ...item, subItems: subItems })
      })
      return result
    },
    drawer: {
      get() {
        return this.$store.state.drawer
      },
      set(value) {
        this.$store.commit('TOGGLE_DRAWER', value)
      },
    },
    isDocument() {
      return this.$route.name === 'document'
    },
  },
  created() {
    this.drawer = false
  },
  methods: {
    nav(link) {
      if (this.isDocument) {
        this.$root.$emit('whant-close-document', link)
      } else {
        this.$router.push(link)
      }
      this.drawer = false
    },
    isActive(link) {
      if (this.$route.name === 'dictionary' && link === '/dictionaries/list')
        return true
      if (link === '/events' && this.$route.fullPath === '/eventsV2') {
        return false
      }
      return this.$route.fullPath.includes(link)
    },
    userHasRole(roles) {
      return (
        this.$store.state.auth.userRole &&
        this.$store.state.auth.userRole.some(item => roles.includes(item.code))
      )
    },
    isLoaded() {
      return this.$store.state.auth.isLoaded
    },
  },
}
</script>

<template>
  <v-app
    v-if="isLoaded()"
    id="app">
    <v-navigation-drawer
      :width="200"
      v-model="drawer"
      :permanent="$vuetify.breakpoint.mdAndUp"
      fixed
      hide-overlay
      app
      class="sidebar"
    >
      <v-toolbar
        dense
        flat
        dark
        class="sdDrawerToolbar">
        <v-toolbar-title class="title">
          xevel
        </v-toolbar-title>
      </v-toolbar>
      <v-list
        v-for="item in filteredMenuItems"
        :key="item.id"
        dense
        subheader
        class="section"
      >
        <v-subheader
          dark
          class="header">
          {{ $t(`navigation_headers__${item.name}`) }}
        </v-subheader>
        <v-list-tile
          v-for="subItem in item.subItems"
          :key="subItem.id"
          :class="{ routeActive: isActive(subItem.link) }"
          class="nav-item"
          @click="nav(subItem.link)"
        >
          <v-list-tile-title class="nav-item-title">
            {{ $t(`navigation_links__${subItem.name}`) }}
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar
      app
      fixed
      flat
      dense
      class="sdToolbar">
      <v-toolbar-side-icon @click="drawer = !drawer" />
      <v-spacer />
      <user-button />
      <notification-button/>
      <locale-button />
    </v-toolbar>
    <v-content>
      <v-container fluid>
        <slot />
      </v-container>
    </v-content>
    <notification-bar />
  </v-app>
</template>

<style lang="scss" scoped>
.sdDrawerToolbar {
  border-bottom: 1px solid #212121;
}
.sdToolbar {
  border-bottom: 1px solid #dfdfdf;
}
.title {
  text-transform: uppercase;
  user-select: none;
}
.sidebar {
  padding-bottom: 0;
  background-color: #f5f5f5;

  .section {
    padding-bottom: 0;
  }
}
.header {
  height: 35px;
  font-weight: 300;
  background-color: #4d4d4d;
}
/* stylelint-disable */
.nav-item {
  border-bottom: 1px solid #dfdfdf;

  &-title {
    padding-left: 15px;
    font-size: 13px;
    font-weight: 300;
  }

  &.routeActive {
    background-color: #dfdfdf;
  }
}
</style>
